'use client';
import React from 'react';
import { cn } from '@edusense/shared-ui-kit/utils';
import { SocialActionsContainer } from './SocialActions.styles';
import { ActionButtons, BookmarkButton } from './components';
import { useSocialActions } from './hooks/useSocialActions';
/**
 * 통합된 소셜 액션 컴포넌트
 * 
 * 트위터 스타일 앱을 위한 모든 액션 버튼들(좋아요, 리트윗, 답글, 북마크, 조회수)을 제공합니다.
 */ var SocialActions = function(param) {
    var id = param.id, _param_likesCount = param.likesCount, likesCount = _param_likesCount === void 0 ? 0 : _param_likesCount, _param_retweetsCount = param.retweetsCount, retweetsCount = _param_retweetsCount === void 0 ? 0 : _param_retweetsCount, _param_repliesCount = param.repliesCount, repliesCount = _param_repliesCount === void 0 ? 0 : _param_repliesCount, _param_viewsCount = param.viewsCount, viewsCount = _param_viewsCount === void 0 ? 0 : _param_viewsCount, _param_isLiked = param.isLiked, isLiked = _param_isLiked === void 0 ? false : _param_isLiked, _param_isRetweetedByMe = param.isRetweetedByMe, isRetweetedByMe = _param_isRetweetedByMe === void 0 ? false : _param_isRetweetedByMe, _param_isQuotedByMe = param.isQuotedByMe, isQuotedByMe = _param_isQuotedByMe === void 0 ? false : _param_isQuotedByMe, _param_isBookmarked = param.isBookmarked, isBookmarked = _param_isBookmarked === void 0 ? false : _param_isBookmarked, _param_size = param.size, size = _param_size === void 0 ? 'md' : _param_size, _param_variant = param.variant, variant = _param_variant === void 0 ? 'row' : _param_variant, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, _param_showCounts = param.showCounts, showCounts = _param_showCounts === void 0 ? true : _param_showCounts, _param_showBookmarkButton = param.showBookmarkButton, showBookmarkButton = _param_showBookmarkButton === void 0 ? false : _param_showBookmarkButton, _param_showRetweetButton = param.showRetweetButton, showRetweetButton = _param_showRetweetButton === void 0 ? true : _param_showRetweetButton, _param_labels = param.labels, labels = _param_labels === void 0 ? {
        like: '좋아요',
        share: '리트윗',
        comment: '답글',
        view: '조회',
        bookmark: '저장'
    } : _param_labels, onLike = param.onLike, onRetweet = param.onRetweet, onQuote = param.onQuote, onComment = param.onComment, onBookmark = param.onBookmark, ReplyModalComponent = param.ReplyModalComponent;
    var _useSocialActions = useSocialActions({
        id: id,
        isLiked: isLiked,
        isRetweetedByMe: isRetweetedByMe,
        isBookmarked: isBookmarked,
        onLike: onLike,
        onRetweet: onRetweet,
        onQuote: onQuote,
        onComment: onComment,
        onBookmark: onBookmark
    }), liked = _useSocialActions.liked, retweeted = _useSocialActions.retweeted, bookmarked = _useSocialActions.bookmarked, showRetweetOptions = _useSocialActions.showRetweetOptions, isReplyModalOpen = _useSocialActions.isReplyModalOpen, setIsReplyModalOpen = _useSocialActions.setIsReplyModalOpen, retweetOptionsRef = _useSocialActions.retweetOptionsRef, handleLike = _useSocialActions.handleLike, handleRetweetClick = _useSocialActions.handleRetweetClick, handleRetweet = _useSocialActions.handleRetweet, handleQuoteTweet = _useSocialActions.handleQuoteTweet, handleComment = _useSocialActions.handleComment, handleBookmark = _useSocialActions.handleBookmark;
    return /*#__PURE__*/ React.createElement(SocialActionsContainer, {
        className: cn(className, 'relative z-50'),
        onClick: function(e) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, /*#__PURE__*/ React.createElement(ActionButtons, {
        // 상태
        liked: liked,
        retweeted: retweeted,
        bookmarked: bookmarked,
        showRetweetOptions: showRetweetOptions,
        retweetOptionsRef: retweetOptionsRef,
        // 카운트
        likesCount: likesCount,
        retweetsCount: retweetsCount,
        repliesCount: repliesCount,
        viewsCount: viewsCount,
        // 설정
        showBookmarkButton: showBookmarkButton,
        showRetweetButton: showRetweetButton,
        variant: variant,
        size: size,
        showCounts: showCounts,
        labels: labels,
        // 핸들러
        onLike: handleLike,
        onRetweetClick: handleRetweetClick,
        onRetweet: handleRetweet,
        onQuoteTweet: handleQuoteTweet,
        onComment: handleComment,
        onBookmark: handleBookmark
    }), showBookmarkButton && variant === 'spaced' && /*#__PURE__*/ React.createElement(BookmarkButton, {
        size: size,
        showCounts: showCounts,
        labels: labels,
        bookmarked: bookmarked,
        variant: variant,
        onBookmark: handleBookmark
    }), ReplyModalComponent && /*#__PURE__*/ React.createElement(ReplyModalComponent, {
        isOpen: isReplyModalOpen,
        onClose: function() {
            return setIsReplyModalOpen(false);
        },
        tweetId: id
    }));
};
export default SocialActions;
